/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateRatingDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivRatingControllerFindAllParamsGen,
  MrfiktivRatingControllerFindByPartnerIdParamsGen,
  MrfiktivRatingViewmodelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Rating<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags rating
   * @name RatingControllerFindAll
   * @summary Get all ratings
   * @request GET:/rating
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivRatingViewmodelGen)[] })`
   * @response `403` `void` Forbidden.
   */
  ratingControllerFindAll = (query: MrfiktivRatingControllerFindAllParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivRatingViewmodelGen[] }, void>({
      path: `/rating`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags rating
   * @name RatingControllerFindByPartnerId
   * @summary Get all ratings by partner id
   * @request GET:/partner/{partnerId}/rating
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivRatingViewmodelGen)[] })`
   * @response `403` `void` Forbidden.
   * @response `404` `void` Not found.
   */
  ratingControllerFindByPartnerId = (
    { partnerId, ...query }: MrfiktivRatingControllerFindByPartnerIdParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivRatingViewmodelGen[] }, void>({
      path: `/partner/${partnerId}/rating`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags rating
   * @name RatingControllerCreate
   * @summary Post a rating
   * @request POST:/partner/{partnerId}/rating
   * @secure
   * @response `201` `MrfiktivRatingViewmodelGen` The created record
   * @response `400` `void` Bad Request.
   * @response `404` `void` Partner not found.
   * @response `429` `void` Too Many Requests
   */
  ratingControllerCreate = (partnerId: string, data: MrfiktivCreateRatingDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivRatingViewmodelGen, void>({
      path: `/partner/${partnerId}/rating`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
